import { createDeviceTelemetrySaga } from '../Telemetry/deviceTelemetrySagas';
import { DeviceTelemetryType } from '@signageos/common-types/dist/Device/Telemetry/DeviceTelemetryType';
import Responsibility from '../../../Feature/Responsibility';
import ManagementCapability from '../../../NativeDevice/Management/ManagementCapability';
import IGetTelemetryProperties from '../Telemetry/IGetTelemetryProperties';
import { MonitoringLogData } from '@signageos/common-types/dist/Device/MonitoringLog/MonitoringLogData';
import IManagementDriver from '../../../NativeDevice/Management/IManagementDriver';

export const telemetryManagementCapabilitiesSaga = createDeviceTelemetrySaga(
	DeviceTelemetryType.MANAGEMENT_CAPABILITIES,
	Responsibility.CAPABILITIES_MANAGEMENT,
	[],
	getSupportedCapabilities,
);

export async function getSupportedCapabilities({ managementDriver }: IGetTelemetryProperties) {
	const supportedCapabilities: ManagementCapability[] = await getSupportedManagementCapabilities(managementDriver);
	const isCapable: MonitoringLogData[DeviceTelemetryType.MANAGEMENT_CAPABILITIES] = {
		capable: supportedCapabilities,
	};

	return isCapable;
}

export async function getSupportedManagementCapabilities(managementDriver: IManagementDriver) {
	const supportedCapabilities: ManagementCapability[] = [];
	for (const capability of Object.values(ManagementCapability)) {
		const supports: boolean = await managementDriver.managementSupports(capability);
		if (supports) {
			supportedCapabilities.push(capability);
		}
	}
	return supportedCapabilities;
}
